export default __webpack_public_path__ + "media/images/ad_landing_page/Dell-d6b281480ea50d2b991905d6edc41001.png";